import { getTermsValue, resetTerms, setTerms, TJsonQuery } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EConditionTypeLegacy } from '../../../../api-models/common/json_query';

const ID = 'conditionType' as const;
const FIELDS = ['condition_type', 'condition_type__free_appointment_object', 'condition_type__industry'] as const;

const LEGACY_LABELS: Record<EConditionTypeLegacy, string> = {
  [EConditionTypeLegacy.OfficeDecoration]: 'Офисная отделка',
  [EConditionTypeLegacy.FullDecorationNeeded]: 'Под чистовую отделку',
  [EConditionTypeLegacy.MajorRepairNeeded]: 'Требуется капитальный ремонт',
  [EConditionTypeLegacy.CosmeticRepairNeeded]: 'Требуется косметический ремонт',
  [EConditionTypeLegacy.RegularRepair]: 'Типовой ремонт',
  [EConditionTypeLegacy.DesignerRepair]: 'Дизайнерский ремонт',
};

const removeValueFromField =
  (field: (typeof FIELDS)[number], removed: EConditionTypeLegacy) =>
  (jsonQuery: TJsonQuery): TJsonQuery => {
    const current = (getTermsValue(field)(jsonQuery) ?? []) as EConditionTypeLegacy[];
    if (!current.includes(removed)) {
      return jsonQuery;
    }
    const next = current.filter(v => v !== removed);

    return next.length > 0 ? setTerms(field)(jsonQuery)(next) : resetTerms([field])(jsonQuery);
  };

export const conditionTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const office = (getTermsValue('condition_type')(jsonQuery) ?? []) as EConditionTypeLegacy[];
    const trade = (getTermsValue('condition_type__free_appointment_object')(jsonQuery) ?? []) as EConditionTypeLegacy[];
    const industry = (getTermsValue('condition_type__industry')(jsonQuery) ?? []) as EConditionTypeLegacy[];
    const merged = new Set<EConditionTypeLegacy>([...office, ...trade, ...industry]);

    if (merged.size === 0) {
      return null;
    }

    return Array.from(merged).map(t => ({ label: LEGACY_LABELS[t], value: createTagValue(ID, t.toString()) }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const removed = Number(removingTagValue) as EConditionTypeLegacy;

    return FIELDS.reduce((acc, field) => removeValueFromField(field, removed)(acc), jsonQuery);
  },
};
